import { motion } from 'framer-motion';
import { AGENTS, AgentKey } from '../../lib/agents';

interface AgentAvatarProps {
  agent: AgentKey;
  size?: number;
  active?: boolean;
  className?: string;
}

/** Circular agent avatar: colored gradient ring + icon, pulses when active. */
export function AgentAvatar({ agent, size = 40, active = false, className }: AgentAvatarProps) {
  const meta = AGENTS[agent];
  return (
    <div className={`relative flex-shrink-0 ${className ?? ''}`} style={{ width: size, height: size }}>
      {active && (
        <motion.span
          className="absolute inset-0 rounded-full"
          style={{ boxShadow: `0 0 0 2px ${meta.color}` }}
          animate={{ opacity: [0.4, 1, 0.4], scale: [1, 1.12, 1] }}
          transition={{ duration: 1.4, repeat: Infinity, ease: 'easeInOut' }}
        />
      )}
      <div
        className="w-full h-full rounded-full flex items-center justify-center text-white"
        style={{
          background: `radial-gradient(circle at 30% 25%, ${meta.color}, ${meta.color}99 60%, ${meta.color}55)`,
          boxShadow: active ? `0 0 14px ${meta.color}aa` : 'none',
        }}
        title={`${meta.name} — ${meta.role}`}
      >
        {meta.icon}
      </div>
    </div>
  );
}
